/* eslint-disable @typescript-eslint/no-explicit-any */
import Typography from '@mui/material/Typography'
import React from 'react'

import { formatCurrency } from '../../../constants/formats'
import { REFUND_PAYMENT_MODES } from '../../../constants/models'

interface Props {
  data: any
}

const LabelValue = ({ label, value }: { label: string; value: string }) => (
  <>
    <Typography variant="overline">{label}</Typography>
    <Typography ml={2}>{value}</Typography>
  </>
)
const Items: React.FC<Props> = ({ data }) => (
  <>
    <LabelValue label="Email Address" value={data.email} />
    <LabelValue label="First Name" value={data.firstName} />
    <LabelValue label="Last Name" value={data.lastName} />
    <LabelValue label="Payment Mode" value={data.paymentMode} />
    <LabelValue
      label="Amount Paid"
      value={formatCurrency(Number(data.amountPaid))}
    />
    {data.paymentMode === REFUND_PAYMENT_MODES.BANK.key && (
      <>
        <LabelValue label="Bank Name" value={data.bankName} />
        <LabelValue label="Account Name" value={data.accountName} />
      </>
    )}
    <LabelValue
      label={`${
        data.paymentMode === REFUND_PAYMENT_MODES.BANK.key ? 'Account' : 'GCash'
      } number`}
      value={data.accountNumber}
    />
  </>
)
export default Items
